//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './WarningBox.less'

class WarningBox extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ])
    };

    static defaultProps = {
        children: '',
    };

    render() {
        const {children} = this.props;

        return (
            <div className="ir-warning-box">{children}</div>
        );
    }

}

export default WarningBox



/** WEBPACK FOOTER **
 ** ./src/components/Modules/WarninigBox/WarningBox.js
 **/